import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import type { GridSize } from '@/types/chart'

export type DrawingTool =
  | 'cursor'
  | 'crosshair'
  | 'trendline'
  | 'hline'
  | 'vline'
  | 'rectangle'
  | 'text'
  | 'measure'
  | 'eraser'

interface LayoutStore {
  gridSize: GridSize
  drawingToolbarOpen: boolean
  watchlistOpen: boolean
  activeTool: DrawingTool
  setGridSize: (size: GridSize) => void
  toggleDrawingToolbar: () => void
  toggleWatchlist: () => void
  setActiveTool: (tool: DrawingTool) => void
}

export const useLayoutStore = create<LayoutStore>()(
  persist(
    (set) => ({
      gridSize: 1,
      drawingToolbarOpen: true,
      watchlistOpen: true,
      activeTool: 'cursor',
      setGridSize: (gridSize) => set({ gridSize }),
      toggleDrawingToolbar: () => set((s) => ({ drawingToolbarOpen: !s.drawingToolbarOpen })),
      toggleWatchlist: () => set((s) => ({ watchlistOpen: !s.watchlistOpen })),
      setActiveTool: (activeTool) => set({ activeTool }),
    }),
    { name: 'mhp-layout' }
  )
)
